import { BaseModal, CloseButton } from "@classdojo/web/components/modals";
import { BaseModalProps } from "@classdojo/web/components/modals/Base";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class OldAppModal extends React.Component<BaseModalProps> {
  render() {
    const props = {
      ...this.props,
      overlayStyle: { ...overlayStyle },
      sx: { ...modalStyle },
    };

    return (
      <BaseModal data-name="old_app_modal:render:base_modal" {...props}>
        {props.onRequestHide && (
          <CloseButton data-name="old_app_modal:render:close_button" close={props.onRequestHide} />
        )}
        {props.children}
      </BaseModal>
    );
  }
}

const overlayStyle: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  backgroundColor: RAW_cssValue("rgb(101, 106, 178)"),
};

const modalStyle: ThemeUIStyleObject = {
  position: "absolute",
  top: "0",
  maxWidth: "95%",
  maxHeight: "inital",
  marginY: "dt_s",
  marginX: "auto",
  transform: "none",
  WebkitTransform: "none",
  msTransform: "none",
  borderRadius: "dt_radius_s",
};
